export { default as createAdmin } from './createAdmin';

export type {
  AdminRegisterOnSubmitFunction,
  AdminRegisterOnSubmitPayload,
} from './createAdmin.type';
